const EVENT_TYPES = Object.freeze({
    PRELANDER_VISITED: 'prelanderVisited',
    SWIPE_PRACTICE_SCREEN_VISITED: 'swipePracticeScreenVisited',
    SECOND_PLAYER_VISITED: 'secondPlayerVisited',
    SECOND_PLAYER_PAGEVIEW: 'secondPlayerPageview',
    CAPTAIN_SCREEN_VISITED: 'captainScreenVisited',
    PICK_BEST_PLAYERS_SCREEN_VISITED: 'pickBestPlayersScreenVisited',
    FIRST_PLAYER_VISITED: 'firstPlayerVisited',
    USER_PROPERTIES: 'userProperties',
    V3_PRELANDER_VISITED: 'v3PrelanderVisited',
    V3_PICK_CARDS_ROLE_SCREEN_VISITED: 'v3PickCardsRoleScreenVisited',
    V3_PICK_STAR_CARD_SCREEN_VISITED: 'v3PickStarCardScreenVisited',
    V3_REWARD_SCREEN_VISITED: 'v3RewardScreenVisited',
    V6_PRELANDER_VISITED: 'v6PrelanderVisited',
    V6_SLIDE_3_SCREEN_VISITED: 'v6Slide3ScreenVisited',
    V6_SLIDE_6_SCREEN_VISITED: 'v6Slide6ScreenVisited',
});

const TWITTER_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.SECOND_PLAYER_VISITED]: 'tw-odp7x-olm7t',
    [EVENT_TYPES.SECOND_PLAYER_PAGEVIEW]: 'tw-odp7x-olqx9',
    [EVENT_TYPES.CAPTAIN_SCREEN_VISITED]: 'tw-odp7x-olm7u'
});

const AMPLITUDE_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.PRELANDER_VISITED]: 'Prelander visited',
    [EVENT_TYPES.V3_PRELANDER_VISITED]: 'Prelander visited',
    [EVENT_TYPES.V3_PICK_CARDS_ROLE_SCREEN_VISITED]: 'Pick cards role screen visited',
    [EVENT_TYPES.V3_PICK_STAR_CARD_SCREEN_VISITED]: 'Pick star card screen visited',
    [EVENT_TYPES.V3_REWARD_SCREEN_VISITED]: 'Reward screen visited',
    [EVENT_TYPES.CAPTAIN_SCREEN_VISITED]: 'Captain screen visited',
    [EVENT_TYPES.SWIPE_PRACTICE_SCREEN_VISITED]: 'Swipe practice screen visited',
    [EVENT_TYPES.PICK_BEST_PLAYERS_SCREEN_VISITED]: 'Pick the 9 best players screen visited',
    [EVENT_TYPES.FIRST_PLAYER_VISITED]: '1st player viewed',
    [EVENT_TYPES.SECOND_PLAYER_VISITED]: '2nd player viewed',
    [EVENT_TYPES.V6_PRELANDER_VISITED]: 'v6 Prelander visited',
    [EVENT_TYPES.V6_SLIDE_3_SCREEN_VISITED]: 'v6 Slide #3 screen visited',
    [EVENT_TYPES.V6_SLIDE_6_SCREEN_VISITED]: 'v6 Slide #6 screen visited'
});

const GOOGLE_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.PRELANDER_VISITED]: 'AW-11360483377/ViJSCKq74akZELHwjKkq',
    [EVENT_TYPES.SECOND_PLAYER_VISITED]: 'AW-11360483377/GqwhCLmG5qkZELHwjKkq',
    [EVENT_TYPES.CAPTAIN_SCREEN_VISITED]: 'AW-11360483377/r_hyCLyG5qkZELHwjKkq'
});

const FACEBOOK_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.PRELANDER_VISITED]: 'Prelander visited',
    [EVENT_TYPES.V3_PRELANDER_VISITED]: 'v3 Prelander visited',
    [EVENT_TYPES.V3_PICK_CARDS_ROLE_SCREEN_VISITED]: 'v3 Pick cards role screen visited',
    [EVENT_TYPES.V3_PICK_STAR_CARD_SCREEN_VISITED]: 'v3 Pick star card screen visited',
    [EVENT_TYPES.V3_REWARD_SCREEN_VISITED]: 'v3 Reward screen visited',
    [EVENT_TYPES.CAPTAIN_SCREEN_VISITED]: 'Captain screen visited',
    [EVENT_TYPES.SECOND_PLAYER_VISITED]: '2nd player viewed',
    [EVENT_TYPES.V6_PRELANDER_VISITED]: 'v6 Prelander visited',
    [EVENT_TYPES.V6_SLIDE_3_SCREEN_VISITED]: 'v6 Slide #3 screen visited',
    [EVENT_TYPES.V6_SLIDE_6_SCREEN_VISITED]: 'v6 Slide #6 screen visited'
});

export {
    EVENT_TYPES,
    TWITTER_EVENT_TYPES,
    AMPLITUDE_EVENT_TYPES,
    GOOGLE_EVENT_TYPES,
    FACEBOOK_EVENT_TYPES
};
